import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { userService } from '../../services/userService';
import Notify from '@/components/Notification';

export const useDeleteCareer = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: payload =>
      userService.deleteCareer(payload).then(response => {
        const { status, data } = response;

        if (status === 200) {
          Notify.success({ text: 'Career removed' });
          queryClient.setQueryData([QUERY_KEYS.user.profile], () => data);
          return data;
        }

        return null;
      }),
  });
};
